<template>
    <l-map ref="map"
        style="height: 100%; width: 100%"
        :zoom="zoom"
        :center="center"
        @update:center="centerUpdate"
        @update:zoom="zoomUpdate">

        <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>

        <l-marker v-for="location in locations" :key="location.id" :ref="'marker_' + location.id" :lat-lng="location.location_coordinates">
            <l-icon>
                <img :src="customIcon">
            </l-icon>
            <l-popup >
                <h5 v-html="location.location_name"></h5>
                <p v-html="location.full_address"></p>
            </l-popup>
        </l-marker>
    </l-map>
</template>

<script>
    import {LMap, LMarker, LTileLayer, LIcon, LPopup} from 'vue2-leaflet';
    import 'leaflet/dist/leaflet.css';

    Vue.component('l-map', LMap);
    Vue.component('l-tile-layer', LTileLayer);
    Vue.component('l-marker', LMarker);
    Vue.component('l-icon', LIcon);
    Vue.component('l-popup', LPopup);
    import {EventBus} from "../event-bus";

    export default {
        props: ['locations'],
        mounted() {
            let vm = this;
            EventBus.$on('view-location', (id, coords) => {
                vm.$refs['marker_' + id][0].mapObject.openPopup();
                vm.centerUpdate(coords);
                vm.zoomUpdate(11);
            });
        },
        data() {
            return {
                url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
                zoom: 11,
                center: [35.463421, -97.515117],
                attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
                customIcon: '/images/vendor/leaflet/dist/marker-icon.png'
            };
        },
        computed: {
            bounds() {
                return this.locations.map(location => {
                    return location.location_coordinates;
                });
            }
        },
        watch: {
            locations() {
                if (this.locations.length > 0) {
                    this.$refs.map.mapObject.fitBounds(this.bounds);
                }
            }
        },
        methods: {
            zoomUpdate(zoom) {
                this.zoom = zoom;
            },
            centerUpdate(center) {
                this.center = center;
            },
            boundsUpdated(bounds) {
                this.bounds = bounds;
            }
        }
    };
</script>
